/**
 * Extended ViewController template
 *
 * User: lironc
 * Date: 2/18/13
 * Time: 4:52 PM
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');

    var DialogViewController = ViewController.extend({
        LPViewMap: {
            cancelButton: ".lpview_cancelButton",
            okButton: ".lpview_okButton",
            xButton: ".lpview_closeButton",
            description: ".lpview_description"
        },

        initialize: function (constructorData) {
            this.dialogInfo = constructorData.dialogInfo;
            this.okCallback = constructorData.okCallback;
            this.cancelCallback = constructorData.cancelCallback;
            this.dismissCallback = constructorData.dismissCallback;
            this.xEnabled = typeof constructorData.xEnabled !== "undefined" ? constructorData.xEnabled : true;

            // By default we want the OK button to be in focus, so if we did not receive any value, setting it as default.
            if (typeof this.dialogInfo.defaultOk === 'undefined') {
                this.dialogInfo.defaultOk = true;
            }

            this.cancelDialogButtonSelected = !this.dialogInfo.defaultOk;

            var templateFile = this.dialogFiles.dialogHTML;
            var styleFile = this.dialogFiles.dialogCSS;

            var hasHTML = lpUtils.hasHtml(this.dialogInfo.description);

            var textInjection = {dialogTitle: this.dialogInfo.title,
                okButton: this.dialogInfo.okButton,
                cancelButton: this.dialogInfo.cancelButton,
                modal: this.dialogInfo.modal ? "modal" : ""
            };

            if (!hasHTML) {
                textInjection.dialogDescription = this.dialogInfo.description;
            }

            this.dialogView = this.createView({
                templateFile: templateFile,
                styleFile: styleFile,
                textInjection: textInjection
            });

            if (hasHTML) {
                this.getFirstElement(this.LPViewMap.description, this.dialogView).innerHTML = this.dialogInfo.description;
            }

            if (!this.dialogInfo.okButton) {
                this.lpHide(this.LPViewMap.okButton, this.dialogView);
            }

            if (!this.dialogInfo.cancelButton) {
                this.lpHide(this.LPViewMap.cancelButton, this.dialogView);
            }

            if (!this.xEnabled) {
                this.lpHide(this.LPViewMap.xButton, this.dialogView);
            }
        },

        events: function () {
            this.bindViewEvent({selector : this.LPViewMap.cancelButton, DOMEvent : "click", callback : this.dismissDialog,
                lpEventData : {canceled : true, confirm : false}
            });
            this.bindViewEvent({selector : this.LPViewMap.okButton, DOMEvent : "click", callback : this.dismissDialog,
                lpEventData : {canceled : false, confirm : true}
            });
            this.bindViewEvent({selector : this.LPViewMap.xButton, DOMEvent : "click", callback : this.dismissDialog,
                lpEventData : {canceled : false, confirm : false}
            });
            this.bindViewEvent({view : this.dialogView, DOMEvent : "keydown", callback : this.keyDownOnDialog});
            this.bindViewEvent({view : this.dialogView, DOMEvent : "keyup", callback : this.keyUpOnDialog,
                lpEventData : {canceled : false, confirm : false}
            });
        },

        render: function () {
            this.dialogView.tabIndex = 1;
            this.dialogView.focus();

            var button;

            if (this.cancelDialogButtonSelected) {
                button = this.getFirstElement(this.LPViewMap.cancelButton);
            } else {
                button = this.getFirstElement(this.LPViewMap.okButton);
            }

            this.addClass(button, this.dialogStates.dialogSelectedButton);
            button = null;

        }
    });

    DialogViewController.prototype.dialogStates = {
        dialogSelectedButton: "operative"
    };

    DialogViewController.prototype.dialogFiles = {
        dialogHTML: "LP_centered_notification_dialog.html",
        dialogCSS: "LP_centered_notification_dialog.css"
    };

    DialogViewController.prototype.keyDownOnDialog = function (e) {
        var keyCode = e.keyCode || e.which;

        if (keyCode === 13) {
            this.preventDefault(e);
            this.touchSession();
        }
    };

    DialogViewController.prototype.keyUpOnDialog = function (e) {
        // Ignoring input dialogs (load custom widgets)
        if (e.sourceElement.nodeName.toLowerCase() === 'input') {
            return;
        }

        var cancelButton = this.getFirstElement(this.LPViewMap.cancelButton);
        var okButton = this.getFirstElement(this.LPViewMap.okButton);

        var dismiss = false;

        var keyCode = e.keyCode || e.which;
        switch (keyCode) {
            case 27: /* ESC */
                dismiss = true;
                e.lpEventData.canceled = false;
                e.lpEventData.confirm = false;
                break;
            case 32: /* Space */
            case 13: /* Enter */
                dismiss = true;
                e.lpEventData.canceled = this.cancelDialogButtonSelected;
                e.lpEventData.confirm = !this.cancelDialogButtonSelected;
                break;
            case 39: /* RIGHT */
                if (this.cancelDialogButtonSelected) {
                    this.removeClass(cancelButton, this.dialogStates.dialogSelectedButton);
                    this.addClass(okButton, this.dialogStates.dialogSelectedButton);
                    this.cancelDialogButtonSelected = false;
                }
                break;
            case 37: /* LEFT */
                if (!this.cancelDialogButtonSelected) {
                    this.addClass(cancelButton, this.dialogStates.dialogSelectedButton);
                    this.removeClass(okButton, this.dialogStates.dialogSelectedButton);
                    this.cancelDialogButtonSelected = true;
                }
                break;
            default:
                break;
        }

        if (dismiss && this.xEnabled) { // TODO: If there are buttons and no X, the enter wont dismiss the dialog.
            this.dismissDialog(e);
        }
        cancelButton = null;
        okButton = null;
    };

    DialogViewController.prototype.dismissDialog = function (e) {
        this.dismissed = true;
        if (e && e.lpEventData && (e.lpEventData.canceled || e.lpEventData.confirm)) {
            if (e.lpEventData.canceled) {
                this.cancelCallback();
            } else {
                this.okCallback();
            }
        } else {
            this.dismissCallback();
        }
        if (!this.disposed) {
            if (this.dialogView) {
                this.dialogView.blur();

                if (e && e.sourceElement) { // The focused element is the clicked element (source)
                    e.sourceElement.blur();
                }
            }

            this.dispose();
        }
    };

    return DialogViewController;

});
